import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, PLATFORM_ID, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '../../../app/core/services/seo.service';
import { CommonService } from '../../../app/core/services/common.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
declare var $:any;

@Component({
  selector: 'app-music-audio-voice',
  templateUrl: './music-audio-voice.component.html',
  styleUrls: ['./music-audio-voice.component.scss'],
  providers: [MessageService]

})
export class MusicAudioVoiceComponent implements OnInit {

constructor(private router : Router,private seo :SeoService, private translate : TranslateService,private titleService : Title,
   private renderer: Renderer2,
     @Inject(PLATFORM_ID) private platformId: Object, private sanitizer: DomSanitizer, private formBuilder: FormBuilder,
     public commonService : CommonService, private el: ElementRef,private cdr: ChangeDetectorRef,private messageService: MessageService) { }
    signUrl = environment.WEB_URL;
   emailValidations: FormGroup;
    plansLoader = false;
    subscriptionPlans = [];
    selectedPlanView = 0;
    domainError = false;
    faqAccordion = [
      {
        "question": "How do I choose between hiring professionals and outsourcing to agencies?",
        "ans": "For focused tasks or smaller projects, hiring professionals is best. For comprehensive or large-scale needs, agencies provide end-to-end solutions."
      },
      {
        "question": "Can Amy.pro help with multilingual voiceover and dubbing services?",
        "ans": "Yes, Amy.pro offers multilingual voiceover and dubbing services to cater to global audiences."
      },
      {
        "question": "What types of music and audio services are available on Amy.pro?",
        "ans": "Amy.pro provides music composition, audio editing, voiceover, podcast production, sound effects creation, and more."
      },
      {
        "question": "How quickly can I get started with a music or audio project?",
        "ans": "You can get started within 24 hours by posting your requirements and being matched with professionals or agencies."
      }
    ]

  ngOnInit(): void {
    this.getPlansDetails();
      this.emailValidations = this.formBuilder.group({
        emailId: [
          "",
          [
            Validators.required,
            Validators.email,
            Validators.pattern(
              "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
            ),
          ],
        ],
      });
    }

    ngAfterViewInit(): void {
      // Store the heights of all content wrappers
      this.contentHeights = this.contentWrappers.map(
       (wrapper) => wrapper.nativeElement.scrollHeight
     );
   }
  
    get f(): { [key: string]: AbstractControl } {
      return this.emailValidations.controls;
    }
  
    validateEmailDomain(email) {
      this.commonService.validateEmailDomains(email).subscribe((res: any) => {
        if (res) {
        } else {
          this.showError("Enter valid email address");
        }
      });
    }
  
    showError(message) {}
  
  
    onSubmit() {
      // Mark all controls as touched to trigger validation errors
      this.markFormGroupTouched(this.emailValidations);
      if (this.emailValidations.valid) {
        this.commonService.validateEmailDomains($('#workmail').val()).subscribe((res: any) => {
          this.domainError = false;
          if (res) {
            const newTab = this.renderer.createElement('a');
            this.renderer.setAttribute(newTab, 'href', this.signUrl + 'get-started/u/setup-profile?workmail=' + $('#workmail').val());
            this.renderer.setAttribute(newTab, 'target', '_blank');
            this.renderer.appendChild(document.body, newTab);
            newTab.click();
            this.renderer.removeChild(document.body, newTab);
          } else {
            this.domainError = true;
            this.messageService.add({
              severity: 'error',
              detail: 'Enter a valid workmail.',
            });
            return;
          }  
        });
      } else {
        if (this.emailValidations.invalid) {
          if (this.emailValidations.get('emailId')?.hasError('required')) {
            this.messageService.add({
              severity: 'error',
              detail: 'Email is required.',
            });
          } else if (
            this.emailValidations.get('emailId')?.hasError('email') ||
            this.emailValidations.get('emailId')?.hasError('pattern')
          ) {
            this.messageService.add({
              severity: 'error',
              
              detail: 'Please enter a valid email.',
            });
          }
          return;
        }
      }  
    }
  
    
    // Helper method to mark all controls in a form group as touched
    private markFormGroupTouched(formGroup: FormGroup) {
      Object.values(formGroup.controls).forEach((control) => {
        control.markAsTouched();
  
        if (control instanceof FormGroup) {
          this.markFormGroupTouched(control);
        }
      });
    }


  public getPlansDetails(){

    this.plansLoader = true;
    this.commonService.getAllNewPlans({type: [0,1,2,3,4,5,6]}).subscribe((res : any) => {
      const planDetails = res.message;
      let allPlans = [...planDetails[0], ...planDetails[5]];
      allPlans.pop();  // Removes the last element from the array
      this.subscriptionPlans = allPlans;      
      this.plansLoader = false;
    }, err=> {
      this.plansLoader = false;
    });
  }

  getAppNameByKey(key: string): string {
    const nameMap = {
      amy: 'Amy',
      amyCms: 'Amy CMS',
      connect: 'Amy Connect',
      enterpriseAi : 'Enterprise AI (Ask Amy)'
    };

    return nameMap[key] || '';
  }
  featuresToDisplay(plan) {
    return this.selectedPlanView === 0 ? plan.features : (plan.features_yearly ? plan.features_yearly : plan.features);
  }

  expandedIndex = 0;
  togglePanel(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
}
      @ViewChildren('contentWrapper') contentWrappers!: QueryList<ElementRef>;
      contentHeights: number[] = [];  

}